var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"title":"pdf预览","scrolling":"no","src":("/pdf/web/viewer.html?file=" + _vm.pdfUrl)}})}
var staticRenderFns = []

export { render, staticRenderFns }